// utils/validationUtils.js
export const validateForm = (formData, schema) => {
    let errors = {};
  
    Object.keys(schema).forEach((field) => {
      const rules = schema[field];
      const value = formData[field];
  
      // Handle required (can be a boolean or a function)
      const isRequired = typeof rules.required === "function" ? rules.required(formData) : rules.required;
  
      if (isRequired && !value) {
        errors[field] = rules.message || `${field} is required.`;
      }
  
      if (rules.type === "number" && value) {
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          errors[field] = rules.message || `${field} must be a valid number.`;
        }
        if (rules.min !== undefined && numValue < rules.min) {
          errors[field] = rules.message || `${field} must be at least ${rules.min}.`;
        }
        if (rules.max !== undefined && numValue > rules.max) {
          errors[field] = rules.message || `${field} must not exceed ${rules.max}.`;
        }
      }
  
      if (rules.customValidator && typeof rules.customValidator === "function") {
        const errorMessage = rules.customValidator(value, formData);
        if (errorMessage) {
          errors[field] = errorMessage;
        }
      }
    });
  
    return errors;
  };
  